import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import Modal from "react-modal";
import { updateAlertModalState } from "../../Store/Modals/Actions";
Modal.setAppElement("#react-app");

class AlertModal extends Component {
    constructor(props) {
        super(props);

        this.closeModal = this.closeModal.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
    }

    closeModal() {
        const { updateAlertModalState } = this.props;

        updateAlertModalState(false);
    }

    onConfirm() {
        const { updateAlertModalState, alertModalData } = this.props;

        updateAlertModalState(false);
        alertModalData.onConfirm();
    }

    render() {
        const { alertModalOpen, alertModalData } = this.props;

        return (
            <Modal
                isOpen={alertModalOpen}
                onRequestClose={this.closeModal}
                contentLabel={`${alertModalData.name} alert`}
                className="modal-content"
                overlayClassName="modal-container create-account-modal modal-active"
            >
                <div className="modal-body">
                    <div className="row justify-content-center">
                        <div className="col-md-12 text-center">
                            <div className="feature feature-1">
                                <div className="text-block">
                                    <h3>{alertModalData.title}</h3>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 text-center">
                                        <button className="btn btn--primary type--uppercase" type="button" onClick={this.onConfirm} style={{ width: 150 }}>{alertModalData.confirmText}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        alertModalOpen: state.alertModalOpen,
        alertModalData: state.alertModalData
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateAlertModalState: updateAlertModalState
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AlertModal));